import { render, staticRenderFns } from "./News.html?vue&type=template&id=81e2fb82&scoped=true&"
import script from "./News.ts?vue&type=script&lang=ts&"
export * from "./News.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/news/_news.scss?vue&type=style&index=0&id=81e2fb82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e2fb82",
  null
  
)

export default component.exports